<template>
    <div class="size-full rounded-lg border flex flex-col">
          <div class="p-[12px] grow flex flex-col justify-between w-full font-extralight">
            <div><h2 class="flex items-center gap-x-2">Total Employées <Info :size="15" strokeWidth="1.3"/></h2></div>
            <div class="grow flex items-center justify-between">
              <span class="text-[32px] font-light">{{ (series[0]+series[1]) ?? 0 }}</span>
              <div class="w-[50%] h-[180px] flex items-center justify-end">
                <apexchart type="pie" :options="options" :series="series" width="100%" height="100%"></apexchart>
              </div>
            </div>
          </div>
          <button class="w-full p-3 rounded-b-lg font-extralight bg-[#f6f7fb] flex items-center justify-between">
            <span>Voir détails</span>
            <ArrowRight :size="16" strokeWidth="1.3"/>
          </button>
    </div>
</template>
<script>
import {Info,ArrowRight} from 'lucide-vue-next';
export default {
    name: "Employe-card",
    components:{
        Info,ArrowRight
    },
    props:['serie'],
    mounted(){
        this.series = this.serie
    },
    data(){
        return {
            series:[0,0],
            options: {
                chart: {
                    type: 'pie',
                    width: "auto",
                    toolbar: {  
                        show: false
                    },
                },
                labels: ['hommes','femmes'],
                colors: ['#3d82fb','#f4405f'],
                dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            }
        }
    }
}
</script>